const riskLevelLabels: Record<string, string> = {
  minimo: 'Mínimo',
  limitado: 'Limitado',
  alto: 'Alto',
  inaceptable: 'Inaceptable',
};

export function mapRiskLevelLabel(value: string | null | undefined): string {
  if (!value) {
    return '';
  }

  return riskLevelLabels[value] ?? value;
}
